
export const environment = {
  production: 'false',
  BUILD_ENV: 'dev',
  API_URL: 'https://devapi.safetk.app/',
  CONNECTION_STRING_NAME: 'Azure Stilwell Portal',
  SIGNALR_URL: 'https://devapi.safetk.app/signalr'
};
